export default "__VITE_ASSET__BQvBm_jX__"